import { getShortId } from "@/lib/string";
import { classNames } from "@/lib/utils";
import {} from "@components/library/IconButton";
import { hlToast } from "@components/library/Toast";
import { ToastVariant } from "@components/library/Toast";
import { EntityIconType, getIconComponentByType } from "@components/library/Entities/EntityIcon";
import { ClickToCopyWrapper } from "@components/library/IdDisplay";
import Tooltip from "@components/library/Tooltip";

const DrawerEntityIcon = ({ entityType, className }: { entityType: EntityIconType; className?: string }) => {
  const IconComponent = getIconComponentByType(entityType);
  return <IconComponent weight="fill" className={classNames("h-14 w-14", className)} />;
};

export const DrawerTitle = ({
  title,
  entityType,
  entityId,
  copyText,
}: {
  title: string;
  entityType: EntityIconType;
  entityId: string;
  /**
   * This is something like 'Session ID', 'Version ID', 'File ID', etc.
   */
  copyText?: string;
}) => {
  return (
    <div className="flex items-center pl-16">
      <div className="flex items-center gap-6">
        <DrawerEntityIcon entityType={entityType} className="text-text-base-3" />
        <span className="text-12-12 font-medium text-text-base-3">{title}</span>
      </div>
      <Tooltip content={`Copy ${copyText ?? "ID"}`}>
        <div
          className="flex items-center pl-12"
          onClick={() => {
            navigator.clipboard.writeText(entityId);
            hlToast({
              title: `Copied ${copyText ?? "ID"} to clipboard`,
              variant: ToastVariant.Success,
            });
          }}
        >
          <span className="cursor-pointer  font-mono text-12-12 font-normal text-text-base-3">
            {getShortId(entityId)}
          </span>
        </div>
      </Tooltip>
    </div>
  );
};
